import { defineNuxtPlugin } from "nuxt/app";
import { configure, defineRule, Form, Field, ErrorMessage } from 'vee-validate';
import { localize, setLocale } from '@vee-validate/i18n';
import ja from '@vee-validate/i18n/dist/locale/ja.json';
import * as rules from '@vee-validate/rules';

export default defineNuxtPlugin((nuxtApp) => {
  Object.entries(rules).forEach(([id, validator]) => {
    if (validator instanceof Function) {
      defineRule(id, validator);
    }
  });

  // 終了年が入力されている場合：終了月が入力されていないときはエラー
  defineRule('requiredEndAtYear', (value, [target], { field, form }) => {
    if (value) {
      if (form[target] === null || form[target] === '') {
        return `${field}は${target}の選択が必須です`;
      }
    }
    return true;
  });

  // 終了月が入力されている場合：終了年が入力されていないときはエラー
  defineRule('requiredEndAtMonth', (value, [target], { field, form }) => {
    if (value) {
      if (form[target] === null || form[target] === '') {
        return `${field}は${target}の選択が必須です`;
      }
    }
    return true;
  });

  // 終了年が入力されている場合：終了月が入力されていないときはエラー
  defineRule('requiredAcquiredAtYear', (value, [target], { field, form }) => {
    if (value && form[target] !== null) {
      return true;
    } else {
      return `${field}は${target}の選択が必須です`;
    }
  });

  // 終了月が入力されている場合：終了年が入力されていないときはエラー
  defineRule('requiredAcquiredAtMonth', (value, [target], { field, form }) => {
    if (value && form[target] !== null) {
      return true;
    } else {
      return `${field}は${target}の選択が必須です`;
    }
  });

  // 誕生日のルール
  defineRule('requiredBirthday', (value, [targetA, targetB], { field, form }) => {
    if (value && form[targetA] !== null && form[targetB] !== null) {
      return true;
    } else {
      return `${field}は${targetA}、${targetB}の選択が必須です`;
    }
  });

  nuxtApp.vueApp.component('ValidationForm', Form);
  nuxtApp.vueApp.component('ValidationField', Field);
  nuxtApp.vueApp.component('ValidationErrorMessage', ErrorMessage);
  configure({
    generateMessage: localize({ ja }),
  });
  setLocale('ja');
});
